import React from 'react';
import { Box, Heading, Image } from '@wix/design-system';
import WixLogoSquare from '../../../assets/images/wixLogoSquare.svg';
import { ArrowLeftSmall, ArrowRightSmall } from '@wix/wix-ui-icons-common';
import css from './Header.scss';
export const Header = _ref => {
  let {
    appImageUrl,
    titleText
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP2",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    flex: "0 0 auto"
  }, /*#__PURE__*/React.createElement(WixLogoSquare, {
    className: css.wixLogo
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(ArrowLeftSmall, null), /*#__PURE__*/React.createElement(ArrowRightSmall, null)), /*#__PURE__*/React.createElement(Image, {
    width: "41px",
    height: "41px",
    src: appImageUrl,
    className: css.appLogo
  })), /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h1"
  }, titleText));
};
//# sourceMappingURL=Header.js.map